<template>
    <div
        class="float_container"
        ref="floatRef"
        v-show="floatShow"
        @mouseover="clearFloat"
        @mouseout="starFloat"
    >
        <a href="#" target="_blank">
            <img class="float_img" :src="floatAdvBanner[0].address" />
        </a>
        <div class="float_close" @click.stop="handleFloatClose">
            <i class="iconfont icon-guanbi"></i>
        </div>
    </div>
</template>

<script>
let intervalTimer;
export default {
    props: {
        floatAdvBanner: {
            type: Array,
            default: () => {
                return [];
            },
            required: true,
        },
    },
    data() {
        return {
            xPos: 0,
            yPos: 0,
            xin: true,
            yin: true,
            step: 1,
            delay: 20,
            height: 0,
            Hoffset: 0,
            Woffset: 0,
            yon: 0,
            xon: 0,
            pause: true,
            floatShow: true,
        };
    },

    created() {},
    mounted() {
        intervalTimer = setInterval(this.changePos, this.delay);
    },
    beforeDestroy() {
        clearInterval(intervalTimer);
    },

    methods: {
        handleFloatClose() {
            this.floatShow = false;
            clearInterval(intervalTimer);
        },
        changePos() {
            let width = document.documentElement.clientWidth;
            let height = document.documentElement.clientHeight;
            this.Hoffset = this.$refs.floatRef.offsetHeight; //获取元素高度
            this.Woffset = this.$refs.floatRef.offsetWidth;

            // 滚动部分跟随屏幕滚动
            this.$refs.floatRef.style.left =
                this.xPos +
                document.body.scrollLeft +
                document.documentElement.scrollLeft +
                'px';
            this.$refs.floatRef.style.top =
                this.yPos +
                document.body.scrollTop +
                document.documentElement.scrollTop +
                'px';

            // 滚动部分不随屏幕滚动
            // this.$refs.floatRef.style.left =
            //     this.xPos + document.body.scrollLeft + 'px'
            // this.$refs.floatRef.style.top =
            //     this.yPos + document.body.scrollTop + 'px'

            if (this.yon) {
                this.yPos = this.yPos + this.step;
            } else {
                this.yPos = this.yPos - this.step;
            }
            if (this.yPos < 0) {
                this.yon = 1;
                this.yPos = 0;
            }
            if (this.yPos >= height - this.Hoffset) {
                this.yon = 0;
                this.yPos = height - this.Hoffset;
            }

            if (this.xon) {
                this.xPos = this.xPos + this.step;
            } else {
                this.xPos = this.xPos - this.step;
            }
            if (this.xPos < 0) {
                this.xon = 1;
                this.xPos = 0;
            }
            if (this.xPos >= width - this.Woffset) {
                this.xon = 0;
                this.xPos = width - this.Woffset;
            }
        },
        clearFloat() {
            clearInterval(intervalTimer);
        },
        starFloat() {
            if (!this.floatShow) {
                clearInterval(intervalTimer);
                return;
            }
            intervalTimer = setInterval(this.changePos, this.delay);
        },
    },
};
</script>

<style lang="scss" scoped>
.float_container {
    height: 165px;
    width: 295px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    .float_img {
        display: block;
        height: 165px;
        width: 295px;
        object-fit: cover;
    }
    .float_close {
        position: absolute;
        right: 0;
        top: 0;
        transform: translateY(-100%);
        cursor: pointer;
        width: 18px;
        height: 18px;
        color: #fff;
        background-color: #999;
        display: flex;
        align-items: center;
        justify-content: center;
        .icon-guanbi {
            font-size: 8px;
        }
    }
}
</style>
